





















































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import { GetNoticeResponse } from "@/typescript/api_client/emesh_api/notifications/types";
import DisplayFilterMenuComponent from "@/components/pages/users/DisplayFilterMenuComponent.vue";
import { getUsersEditApi } from "@/typescript/api_client/emesh_api/users/users_edit_api";
import { getUsersgroupsApi } from "@/typescript/api_client/emesh_api/users/usergroups_api";
import { DisplayFilterMenu } from "@/typescript/pages/users/index.ts";
import { GetCompanyResponse } from "@/typescript/api_client/emesh_api/master/types";
import {
  GetUsergroupResponse,
  GetUsersEditResponse
} from "@/typescript/api_client/emesh_api/users/types";
import {
  ValidList,
  Valid,
  AlertFilterList,
  AlertFilter,
  SelectedUsergroup
} from "@/typescript/pages/users/types";
export {
  ValidList,
  Valid,
  AlertFilterList,
  AlertFilter,
  SelectedUsergroup,
  DisplayFilterMenu,
  GetNoticeResponse,
  GetCompanyResponse,
  GetUsergroupResponse,
  GetUsersEditResponse
};

@Component({
  components: {
    DisplayFilterMenuComponent,
    SelectComponent,
    InputTextComponent
  }
})
export default class UserMasterHeaderComponent extends Vue {
  isFilter: boolean = false;
  selectWidth: string = "200px";
  selectLargeWidth: string = "350px";
  inputWidth: string = "500px";
  usergroups: GetUsergroupResponse[] = [];
  usersEdit: GetUsersEditResponse | {} = {};
  pageNo: number = 1;
  pageCount: number = 10;
  validList: ValidList = {
    0: { name: "無効", value: 0 },
    1: { name: "有効", value: 1 }
  };
  alertFilterList: AlertFilterList = {
    0: { name: "通知する", value: 0 },
    2: { name: "通知しない", value: 2 }
  };

  @Prop()
  searchValue!: string;

  @Prop()
  inputMailAddress!: string;

  @Emit()
  enterMailAddress(value: string): string {
    return value;
  }

  @Emit()
  changeValid(valid: Valid) {
    return valid;
  }

  @Emit()
  changeAlertFilter(alertFilter: AlertFilter) {
    return alertFilter;
  }

  @Emit()
  changeUsergroup(usergroup: SelectedUsergroup) {
    return usergroup;
  }

  @Emit()
  changeUserName(userName: SelectedUsergroup) {
    return userName;
  }

  @Emit()
  enterSearchValue(event: KeyboardEvent) {
    const inputEvent = event.target as HTMLInputElement;
    return inputEvent.value;
  }

  @Emit()
  changeInputMailAddress(value: string): string {
    return value;
  }

  get internalSearchValue(): string {
    return this.searchValue;
  }

  set internalSearchValue(value: string) {
    this.searchValue = value;
  }

  setUsergroups() {
    getUsersgroupsApi().then((resp: GetUsergroupResponse[]) => {
      this.usergroups = resp;
    });
  }

  setUsersEdit() {
    getUsersEditApi().then((resp: GetUsersEditResponse) => {
      this.usersEdit = resp;
    });
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  created() {
    this.setUsersEdit();
    this.setUsergroups();
  }
}
